import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import HcpcsCode from "../../../../Utility/Crud/HcpcsCode";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminHcpcsCodeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "code", name: "Code", type: "string", width: "200px" },
            {
              key: "descriptionLong",
              name: "Long Description",
              type: "string",
            },
            {
              key: "descriptionShort",
              name: "Short Description",
              type: "string",
              width: "300px",
            },
          ]}
          rows={HcpcsCode.sort(Object.values(this.context.hcpcsCodesIndexed))}
          onClick={(hcpcsCode) => {
            this.props.history.push({
              pathname: "/admin/hcpcsCode/" + hcpcsCode.id,
            });
          }}
        />
      );
    }
  },
);
